module.exports = __webpack_public_path__ + "static/img/tzbjs.9ee3558b.png";